var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 4.5H18.75V3.5C18.75 2.9 18.35 2.5 17.75 2.5C17.15 2.5 16.75 2.9 16.75 3.5V4.5H8.75V3.5C8.75 2.9 8.35 2.5 7.75 2.5C7.15 2.5 6.75 2.9 6.75 3.5V4.5H5.75C4.05 4.5 2.75 5.8 2.75 7.5V8.5H22.75V7.5C22.75 5.8 21.45 4.5 19.75 4.5ZM2.75 19.5C2.75 21.2 4.05 22.5 5.75 22.5H19.75C21.45 22.5 22.75 21.2 22.75 19.5V10.5H2.75V19.5ZM17.75 12.5C18.35 12.5 18.75 12.9 18.75 13.5C18.75 14.1 18.35 14.5 17.75 14.5C17.15 14.5 16.75 14.1 16.75 13.5C16.75 12.9 17.15 12.5 17.75 12.5ZM17.75 16.5C18.35 16.5 18.75 16.9 18.75 17.5C18.75 18.1 18.35 18.5 17.75 18.5C17.15 18.5 16.75 18.1 16.75 17.5C16.75 16.9 17.15 16.5 17.75 16.5ZM12.75 12.5C13.35 12.5 13.75 12.9 13.75 13.5C13.75 14.1 13.35 14.5 12.75 14.5C12.15 14.5 11.75 14.1 11.75 13.5C11.75 12.9 12.15 12.5 12.75 12.5ZM12.75 16.5C13.35 16.5 13.75 16.9 13.75 17.5C13.75 18.1 13.35 18.5 12.75 18.5C12.15 18.5 11.75 18.1 11.75 17.5C11.75 16.9 12.15 16.5 12.75 16.5ZM7.75 12.5C8.35 12.5 8.75 12.9 8.75 13.5C8.75 14.1 8.35 14.5 7.75 14.5C7.15 14.5 6.75 14.1 6.75 13.5C6.75 12.9 7.15 12.5 7.75 12.5ZM7.75 16.5C8.35 16.5 8.75 16.9 8.75 17.5C8.75 18.1 8.35 18.5 7.75 18.5C7.15 18.5 6.75 18.1 6.75 17.5C6.75 16.9 7.15 16.5 7.75 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/Calender-icon.719f2c8c156707ec98a81da09abde00e.svg";
export { ForwardRef as ReactComponent };